/**
 * didParamsChange
 * Determines if table fetch params have changed.
 */
export const didParamsChange = ({ className, columns, page, pageSize, sorting, total }, props) =>
  className !== props.className ||
  columns !== props.columns ||
  page !== props.page ||
  pageSize !== props.pageSize ||
  sorting !== props.sorting ||
  total !== props.total;

/**
 * getTableHeight
 * gets the height of the table body when Body's setTableHeight is called.
 */
export const getTableHeight = (tableTop, windowHeight, tableScrollHeight) => {
  let tableHeight = 'auto';
  if (tableTop < windowHeight) {
    const calculatedTableHeight = windowHeight - tableTop;
    tableHeight =
      calculatedTableHeight < tableScrollHeight ? `${calculatedTableHeight}px` : tableHeight;
  }
  return tableHeight;
};
